import { NgModule } from '@angular/core';

import { YearDatePipe } from './yaer.pipe';

@NgModule({
  imports: [],
  declarations: [YearDatePipe],
  exports: [YearDatePipe],
})
export class YearPipeModule {
  static forRoot() {
    return {
      ngModule: YearPipeModule,
      providers: [],
    };
  }
}
